import { Component, OnInit } from '@angular/core';
import { ApplicationSteps } from "../../../../models/applications.models";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { AuthService } from "../../../../../services/auth.service";

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss'],
    standalone: false
})
export class SignatureComponent extends ApplicationSectionBaseComponent implements OnInit {

    readonly step: ApplicationSteps = ApplicationSteps.Signature;



    constructor(_auth: AuthService) { super(_auth); }

    ngOnInit() {
    }

    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }

}
